import { format, parse, parseISO } from 'date-fns';

const parseDateValue = (date: Date | string) => {
  if (date instanceof Date) {
    return date;
  }

  if (date.includes('/')) {
    return parse(date, 'yyyy/MM/dd', new Date());
  }

  return parseISO(date);
};

export const formatDate = (date: Date | string) => format(parseDateValue(date), 'dd/MM/yyyy');
